import React, { FC, useMemo } from "react";
import { useSelector } from "react-redux";
import { AttributeSelectorType, AttributeType } from "@evergis/api";

import { FeatureAttributesContainer } from "../../styled";
import { AttributeHandBook } from "./components/AttributeHandBook";
import { FeatureAttributeField } from "./FeatureAttributeField";

import { getCurrentFeature } from "../../../../ducks/selectFeatures/selectors";

import { FeatureAttributesProps } from "./types";

export const FeatureAttributes: FC<FeatureAttributesProps> = ({ attributes, layer, setHandBookReference }) => {
  const currentFeature = useSelector(getCurrentFeature);

  const attributesWithHandbook = useMemo(() => {
    const layerAttributes = layer?.configuration.attributesConfiguration?.attributes || [];

    return layerAttributes
      ?.filter(({ attributeSelectorType }) => attributeSelectorType === AttributeSelectorType.ViewHandBook)
      .map(({ attributeName }) => attributeName);
  }, [layer]);

  const rawAttributes = useMemo(() => {
    if (layer.layerDefinition !== undefined) {
      return [];
    }

    return currentFeature?.attributes !== undefined
      ? Object.entries(currentFeature?.attributes).map(([key, value]) => ({
          name: key,
          alias: key,
          description: "",
          value,
          type: AttributeType.String,
        }))
      : [];
  }, [currentFeature?.attributes, layer?.layerDefinition]);

  return (
    <FeatureAttributesContainer>
      {[...attributes, ...rawAttributes].map((attribute, attributeId) =>
        attributesWithHandbook.includes(attribute.name) ? (
          <AttributeHandBook
            key={`feature-attribute-${attribute.name}-${attribute.type}-${attributeId}`}
            layer={layer}
            attribute={attribute}
            setHandBookReference={setHandBookReference}
          />
        ) : (
          <FeatureAttributeField
            key={`feature-attribute-${attribute.name}-${attribute.type}-${attributeId}`}
            attribute={attribute}
          />
        ),
      )}
    </FeatureAttributesContainer>
  );
};
